import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { dashboardExpensesData } from "../../../ApiService/ApiService";
import { BarChart } from "@mui/x-charts";

function Expenses({ schoolId, sessions, sessionsError, sessionsLoading }) {
  const [sessionId, setSessionId] = useState("");
  const [expensesData, setExpensesData] = useState(null);
  const [barDataCategory, setBarDataCategory] = useState({
    xAxis: [],
    series: [],
  });
  const [barDataMonth, setBarDataMonth] = useState({ xAxis: [], series: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (sessionId) {
      setLoading(true);
      setError(null);
      dashboardExpensesData(sessionId, schoolId)
        .then((response) => {
          const data = response.data.data;
          setExpensesData(data);

          const categoryData = data.byCategory;
          const categoryLabels = Object.keys(categoryData);
          const categoryValues = Object.values(categoryData);

          setBarDataCategory({
            xAxis: categoryLabels,
            series: [
              {
                label: "Expenses by Category",
                data: categoryValues,
                color: "red",
              },
            ],
          });

          const monthData = data.byMonth;
          const monthLabels = Object.keys(monthData);
          const monthValues = Object.values(monthData);

          setBarDataMonth({
            xAxis: monthLabels,
            series: [
              {
                label: "Expenses by Month",
                data: monthValues,
                color: "red",
              },
            ],
          });

          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching expenses data:", error);
          setError("Error fetching expenses data");
          setLoading(false);
        });
    }
  }, [sessionId, schoolId]);

  useEffect(() => {
    if (sessions?.data?.length > 0) {
      setSessionId(sessions.data[0].id);
    }
  }, [sessions]);

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <FormControl required size="small" sx={{ width: "25%", marginBottom: 2 }}>
        <InputLabel id="sessions">Sessions</InputLabel>
        <Select
          name="sessionId"
          label="Sessions"
          labelId="sessions"
          value={sessionId}
          onChange={(e) => setSessionId(e.target.value)}
          size="small"
          disabled={sessionsLoading || sessionsError}
        >
          {sessionsLoading ? (
            <MenuItem value="">
              <CircularProgress size={24} />
            </MenuItem>
          ) : sessionsError ? (
            <MenuItem value="">
              <Alert severity="error">Error fetching sessions</Alert>
            </MenuItem>
          ) : (
            sessions?.data?.map((currSession) => (
              <MenuItem key={currSession.id} value={currSession.id}>
                {currSession.name}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress size={48} />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : expensesData ? (
        <>
          <Typography
            variant="h6"
            sx={{ marginBottom: 5, marginTop: 2, fontWeight: "bold" }}
          >
            Total Year Expense: Rs. {expensesData.yearExpense}
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ marginBottom: 1, fontWeight: "bold" }}
              >
                Expenses by Category
              </Typography>
              <BarChart
                xAxis={[{ scaleType: "band", data: barDataCategory.xAxis }]}
                series={barDataCategory.series}
                width={300}
                height={250}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ marginBottom: 1, fontWeight: "bold" }}
              >
                Expenses by Month
              </Typography>
              <BarChart
                xAxis={[{ scaleType: "band", data: barDataMonth.xAxis }]}
                series={barDataMonth.series}
                width={300}
                height={250}
              />
            </Box>
          </Box>
        </>
      ) : (
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          Please select a session to view expenses data.
        </Typography>
      )}
    </Box>
  );
}

export default Expenses;
